import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.46 0.7A1.25 1.25 0 0 0 11.21 2v10.12a0.25 0.25 0 0 1 -0.25 0.25H8.8a1 1 0 0 0 -0.7 1.71l3.65 3.65a1 1 0 0 0 1.41 0l3.66 -3.65A1 1 0 0 0 17 13a1 1 0 0 0 -0.92 -0.62H14a0.25 0.25 0 0 1 -0.25 -0.25V2A1.25 1.25 0 0 0 12.46 0.7Z",
		fill: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.75 22a1.25 1.25 0 0 0 -1.25 -1.25h-21a1.25 1.25 0 0 0 0 2.5h21A1.25 1.25 0 0 0 23.75 22Z",
		fill: "currentColor",
		strokeWidth: 1
	})] })
});
export { SvgDownload as ReactComponent };
